export const config =  {
    header_right:"Roberto Hizon Jr",
    theme:{
        dark:'dracula',
        light:'default'
    },
    links:
    {
        myportfolio:'http://myportfolio-061919.s3-website.us-east-2.amazonaws.com/'
    }
}